import {getMethod, putMethod} from '~/api'

async function get(hotelId) {
    return await getMethod(`/api/hotelDescription/${hotelId}/amenities`)
}

async function put(hotelId, request) {
    return await putMethod(`/api/hotelDescription/${hotelId}/amenities`, request)
}

export {get, put}
